interface Props {
  containerElement: HTMLDivElement;
}

interface Response {
  body: string;
  logged_in: boolean;
  campaign_id: string;
  campaign_name: string;
}

const adjustDocumentSize = (containerElement: HTMLDivElement) => {
  if (window.location.pathname === '/') return;

  const fixedElement = containerElement.querySelector('.sticky-footer-container-old');
  if (fixedElement) {
    const fixedElementHeight = fixedElement.clientHeight;
    containerElement.style.height = fixedElementHeight.toString() + "px";
  }

  const fixedElementNew = containerElement.querySelector('.sticky-footer-container');
  if (fixedElementNew) {
    const fixedElementNewHeight = fixedElementNew.clientHeight;
    containerElement.style.height = fixedElementNewHeight.toString() + "px";
  }
}

const closeSticky = (containerElement: HTMLDivElement) => {
  containerElement.classList.remove('display-flex');
  sessionStorage.setItem('sticky-closed', 'true');
}

const showOrHideFooter = (containerElement: HTMLDivElement) => {
  
  // Check if sticky was already closed with 'X' button
  const manuallyClosed = sessionStorage.getItem('sticky-closed') === 'true';
  
  if (window.scrollY > 200 && !manuallyClosed) {
    containerElement.classList.add('display-flex'); 
  } else {
    containerElement.classList.remove('display-flex'); 
  }
  adjustDocumentSize(containerElement);
}

const init = async (props: Props) => {

  // Check if sticky was already closed with 'X' button
  const manuallyClosed = sessionStorage.getItem('sticky-closed') === 'true';
  
  if (!props.containerElement || manuallyClosed) return;  
  
  const alwaysShowStickyFooter = window.location.pathname === "/magazines";

  window.addEventListener('resize', () => {
    adjustDocumentSize(props.containerElement);
  });

  if (alwaysShowStickyFooter) {
    props.containerElement.classList.add('display-flex');
  } else {
    window.addEventListener('scroll', (event) => {
      showOrHideFooter(props.containerElement)
    });
  }

  const response = await fetch('/api/full/get_sticky_footer_dynamic_content');
  if (response.ok) {
    const json = await response.json() as Response;
    if (!json.logged_in || window.location.pathname == "/") {
      props.containerElement.innerHTML = json.body;
      adjustDocumentSize(props.containerElement);
    }

    const icons = props.containerElement.getElementsByClassName("sticky-footer-x-icon-shared");

    for (let icon of icons) {
      icon.addEventListener('click', () => {
        closeSticky(props.containerElement);
        window.dataLayer.push({
          event: "cta_click",
	        click_type: "close_floatbar",
        })
      });
    }

    const ctaMain = props.containerElement.querySelector('#sticky-footer-cta');
    if (ctaMain) {
      if (json.logged_in) {
        ctaMain.addEventListener('click', () => {
          window.dataLayer.push({
            event: "cta_click",
            click_type: "cta_floatbar_go_readly"
          })
        })
      }
      else {
        ctaMain.addEventListener('click', () => {
          window.dataLayer.push({
            event: "cta_click",
            click_type: "cta_floatbar",
            campaign_id: json.campaign_id,
            campaign_name: json.campaign_name
          })
        })
      }
    }
  }
}

export const StickyFooter = {
  init,
};